import './styles.styl';

export const mini = {
	name: 'mini',
	hiddenParts: ['secondaryText', 'icon'],
};
